import { j as e, c as l } from "./utils-BdNIfrGQ.js";
import { n as b } from "./normalize-spacing-DY0KSpr_.js";
import * as i from "react";
import u, { Children as p } from "react";
import { c as R } from "./index-Di82Y7n3.js";
import { D as n } from "./Div-spVpsZsH.js";
import "./Div.skeleton-DLnqOZrU.js";
import { F as c } from "./Flex-BA9xHq_p.js";
import "./Grid-DJGISvmf.js";
import F from "./components/progress-bar/ProgressBar.mjs";
import { a as $ } from "./Button-CzIiGCVn.js";
import { a as T, b as k } from "./collapsible-DacB5xWd.js";
import { S as B } from "./skeleton-CpjuZTJp.js";
import "./Button.skeleton-D0Onk1OP.js";
import { a as D } from "./Avatar.styles-ocFXjGa8.js";
import { c as H } from "./createLucideIcon-D4r5Phnh.js";
import { H as S } from "./H3-Bopq07l-.js";
const V = [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
], z = H("chevrons-up-down", V), A = R(
  "flex flex-col rounded-3xl overflow-hidden w-full border border-border",
  {
    variants: {
      height: {
        default: "",
        full: "h-full",
        fit: "h-fit"
      },
      shadow: {
        none: "",
        sm: "shadow-sm",
        md: "shadow-md",
        lg: "shadow-lg"
      }
    },
    defaultVariants: {
      height: "default",
      shadow: "none"
    }
  }
), C = i.forwardRef(
  ({ className: a, ...s }, r) => /* @__PURE__ */ e.jsx(n, { ref: r, className: l("bg-card text-card-foreground", a), ...s })
);
C.displayName = "Card";
const N = i.forwardRef(
  ({ className: a, ...s }, r) => /* @__PURE__ */ e.jsx(n, { ref: r, className: l("text-left", a), ...s })
);
N.displayName = "CardHeader";
const f = i.forwardRef(
  ({ className: a, ...s }, r) => (
    // @ts-expect-error todo
    /* @__PURE__ */ e.jsx(S, { ref: r, ...s })
  )
);
f.displayName = "CardTitle";
const P = i.forwardRef(({ className: a, ...s }, r) => /* @__PURE__ */ e.jsx("p", { ref: r, className: l("text-sm text-muted-foreground", a), ...s }));
P.displayName = "CardDescription";
const g = i.forwardRef(
  ({ className: a, ...s }, r) => /* @__PURE__ */ e.jsx(n, { ref: r, className: l("h-full", a), ...s })
);
g.displayName = "CardContent";
const y = i.forwardRef(
  ({ className: a, ...s }, r) => /* @__PURE__ */ e.jsx(n, { ref: r, className: l("flex items-center", a), ...s })
);
y.displayName = "CardFooter";
const E = (a, s) => {
  switch (a) {
    case "collapsible":
      return /* @__PURE__ */ e.jsx(j, { children: /* @__PURE__ */ e.jsx(m, { children: s }) });
    case "collapsible-multi-body":
      return /* @__PURE__ */ e.jsx(j, { children: p.map(s, (r, t) => r ? /* @__PURE__ */ e.jsx(m, { multiBody: !0, children: r }, t) : null) });
    case "multi-body":
      return /* @__PURE__ */ e.jsx(e.Fragment, { children: p.map(s, (r, t) => r ? /* @__PURE__ */ e.jsx(m, { multiBody: !0, children: r }, t) : null) });
    default:
      return /* @__PURE__ */ e.jsx(m, { children: s });
  }
}, I = ({ header: a, multiBody: s = !1 }) => {
  const { collapsible: r } = a || {};
  return r ? s ? "collapsible-multi-body" : "collapsible" : s ? "multi-body" : "default";
}, oe = (a) => {
  const { height: s, shadow: r, spacing: t, header: o, footer: d, children: w, ...v } = a, x = I(a), _ = x === "collapsible" || x === "collapsible-multi-body";
  return /* @__PURE__ */ e.jsx(
    C,
    {
      className: l(
        A({ height: s, shadow: r }),
        b(t),
        _ ? "py-6 px-7" : "pt-6 px-7 pb-7"
      ),
      ...v,
      children: /* @__PURE__ */ e.jsxs(c, { gap: "5", className: "flex-col h-full", children: [
        o && /* @__PURE__ */ e.jsx(L, { ...o }),
        E(x, w),
        d && /* @__PURE__ */ e.jsx(U, { ...d })
      ] })
    }
  );
}, h = ({ title: a, open: s }) => /* @__PURE__ */ e.jsx(n, { className: "z-1 -mx-6 flex-grow", children: /* @__PURE__ */ e.jsx(T, { asChild: !0, children: /* @__PURE__ */ e.jsx($, { variant: "ghost", size: "full", children: /* @__PURE__ */ e.jsxs(c, { className: "w-full justify-between items-center py-4 px-6", children: [
  /* @__PURE__ */ e.jsx(f, { children: a }),
  /* @__PURE__ */ e.jsx(z, { size: 16, strokeWidth: 2, className: s ? "rotate-180" : "" }),
  /* @__PURE__ */ e.jsx("span", { className: "sr-only", children: "Toggle" })
] }) }) }) }), L = ({ progress: a, title: s, collapsible: r, open: t }) => {
  const o = !!a, { value: d } = a || { value: 0 };
  return /* @__PURE__ */ e.jsxs(N, { className: l("relative flex justify-between items-center"), children: [
    !a && (r ? /* @__PURE__ */ e.jsx(h, { open: t, title: s }) : /* @__PURE__ */ e.jsx(f, { children: s })),
    o && /* @__PURE__ */ e.jsxs(c, { className: "flex-col w-full", children: [
      /* @__PURE__ */ e.jsx(c, { className: "items-center justify-between", children: r ? /* @__PURE__ */ e.jsx(h, { open: t, title: s }) : /* @__PURE__ */ e.jsx(f, { children: s }) }),
      /* @__PURE__ */ e.jsx(F, { color: a.color, value: d, spacing: "4 0 2" })
    ] })
  ] });
}, U = ({ left: a, right: s, ...r }) => /* @__PURE__ */ e.jsx(y, { ...r, children: /* @__PURE__ */ e.jsxs(c, { className: "flex-col sm:flex-row items-center w-full", children: [
  a && /* @__PURE__ */ e.jsx(n, { className: "mb-4 sm:mb-0 mr-auto", children: a.map((t, o) => /* @__PURE__ */ e.jsx(u.Fragment, { children: t }, `card_footer_left_${o}`)) }),
  /* @__PURE__ */ e.jsx(n, { className: "ml-auto", children: s.map((t, o) => /* @__PURE__ */ e.jsx(u.Fragment, { children: t }, `card_footer_right_${o}`)) })
] }) }), m = ({ multiBody: a, ...s }) => /* @__PURE__ */ e.jsx(
  g,
  {
    className: l(a && "[&:not(:last-child)]:border-b-[1px] [&:not(:last-child)]:pb-5"),
    ...s
  }
), j = ({ children: a }) => /* @__PURE__ */ e.jsx(k, { className: "pb-4", children: /* @__PURE__ */ e.jsx(c, { gap: "7", className: "flex-col", children: a }) }), W = ({ size: a, spacing: s, ...r }) => /* @__PURE__ */ e.jsx(
  B,
  {
    className: l(D({ size: a }), b(s), "rounded-full"),
    grayVariant: r.grayVariant,
    ...r
  }
);
W.displayName = "AvatarSkeleton";
export {
  W as A,
  f as C,
  oe as a,
  m as b,
  A as c,
  U as d,
  L as e,
  j as f,
  h as g
};
